<template>
  <div>
    <component id="header" v-if="headerComponentName" :is="headerComponentName" @logout="logout" ></component>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PCHeader from "components/global/partials/GuestHeader/PCHeader.vue"
  import MobileHeader from "components/global/partials/GuestHeader/MobileHeader.vue"

  export default {
    components: {
      PCHeader,
      MobileHeader,
    },
    data () {
      return {}
    },
    computed:{
      headerComponentName(){
        switch(this.$root.bootstrapBreakpoint){
          case "xl":
          case "lg":
              return "PCHeader"
          case "md":
          case "sm":
          case "xs":
            return "MobileHeader"
          default:
            return null
        }
      },
    },
    methods: {
      logout(){
        this.$emit('logout')
      }
    }

  }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// GuestHeader.vue?efebc158